/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Notify_Desc6Inputs */

const en_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification pipelines, deep links, and in-app purchases wired end-to-end, not just registered tokens.`)
};

const ar_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطوط إشعارات وروابط عميقة ومشتريات داخل التطبيق موصولة بالكامل, لا مجرد رموز مسجلة.`)
};

const bn_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নোটিফিকেশন পাইপলাইন, ডিপ লিংক ও ইন-অ্যাপ পেমেন্ট এন্ড-টু-এন্ড ওয়্যারড, শুধু রেজিস্টার্ড টোকেন নয়।`)
};

const de_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungspipelines, Deep Links und In-App-Käufe, durchgängig integriert, nicht nur registrierte Token.`)
};

const es_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de notificación, deep links y compras in-app conectados de extremo a extremo, no solo tokens registrados.`)
};

const fr_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de notification, liens profonds et achats intégrés branchés de bout en bout, pas seulement des jetons enregistrés.`)
};

const pt_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de notificação, deep links e compras no aplicativo conectados de ponta a ponta, não apenas tokens registrados.`)
};

const zh_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知管道、深层链接和应用内购买是端到端连接的，而不仅仅是注册令牌。`)
};

const tr_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim hatları, derin bağlantılar ve uygulama içi satın alımlar, yalnızca kayıtlı token'larla değil, uçtan uca bağlıdır.`)
};

const ru_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пуши, диплинки и in-app покупки, связанные end-to-end, а не просто зарегистрированные токены.`)
};

const pl_svc_mobile_app_development_notify_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potoki powiadomień, głębokie linki i zakupy w aplikacji są połączone kompleksowo, a nie tylko za pomocą zarejestrowanych tokenów.`)
};

/**
* | output |
* | --- |
* | "Notification pipelines, deep links, and in-app purchases wired end-to-end, not just registered tokens." |
*
* @param {Svc_Mobile_App_Development_Notify_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_notify_desc6 = /** @type {((inputs?: Svc_Mobile_App_Development_Notify_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Notify_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_notify_desc6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_notify_desc6(inputs)
	return en_svc_mobile_app_development_notify_desc6(inputs)
});
export { svc_mobile_app_development_notify_desc6 as "svc_mobile-app-development_NOTIFY_desc" }